import { useEffect, useMemo } from 'react';
import { useBoolean } from '@entegral/helpers.react/hooks/boolean';

export function useFiltersInited({ config, filters }) {
  let [ isInited, init ] = useBoolean(false);

  let filtersList = useMemo(() => {
    return [
      `statuses`,
      `areas`,
      `types`,
      `priceFrom`,
      `priceTo`,
      `beds`,
      `baths`,
      `garages`,
      `parking`,
      `buildingSize`,
      `maxBuildingSize`,
      `landSize`,
      `pool`,
      `pets`,
      `flatlet`,
      `staffRooms`,
      `development`,
      `onShow`,
      `reduced`,
      `furnished`,
      `features`,
    ];
  }, []);

  useEffect(() => {
    if (isInited) return;

    let filtersKeys = new Set(Object.keys(filters));
    let allFiltersInited = true;

    for (let filter of filtersList) {
      if (!filtersKeys.has(filter)) {
        allFiltersInited = false;
        break;
      }
    }

    if (allFiltersInited) init();
  }, [filters, filtersList]);

  return isInited;
}
